import { MemberStates } from '@/constants';
import { OrganizationMember } from '@/types';

export const getMemberStateLabel = (state: OrganizationMember['state']) => {
  let label: string = state;
  let color: string = 'members.unassigned';
  switch (state.toLowerCase()) {
    case MemberStates.NEW:
    case MemberStates.USER_CLAIMED:
      label = 'Unassigned';
      color = 'members.unassigned';
      break;
    case MemberStates.PLAN_ASSIGNED:
      label = 'Invited';
      color = 'members.invited';
      break;
    case MemberStates.ACTIVE:
      label = 'Enrolled';
      color = 'members.active';
      break;
    case MemberStates.ARCHIVED:
    case MemberStates.USER_DELETED:
      label = 'Removed';
      color = 'members.removed';
      break;
  }

  return { label, color };
};
